'use strict';

angular.module('app.advertiserInfluencerGroup', [])

.controller('advertiserInfluencerGroupCtrl', ['$scope', '$rootScope', "$http", '$state', '$location', 'commonPagesService', 'TRACK_EVENTS',
    function ($scope, $rootScope, $http, $state, $location, commonPagesService, TRACK_EVENTS) {
    
    $scope.currentUser = $rootScope.currentUser;
    $scope.influencerGroups = [];
    $scope.limitList = 20;
    $scope.showAll = false;
    $scope.selectedAdvertiser = 0;
    $scope.isFetching = false;

    $scope.loadInfluencerGroup = function (selected_company_id) {
        $scope.isFetching = true;
        commonPagesService.getInfluencerGroupByAdvertiserID(selected_company_id, false)
            .then(function (response) {
                $scope.influencerGroups = response.data;
                $scope.isFetching = false;
            }, function () {
                $scope.isFetching = true;
                return false;
            })
            .finally(function () {
            });
    };

    if($scope.currentUser.accessibility.leftMenu.showInfluencerGroup == true) {
        $scope.loadInfluencerGroup($scope.selectedAdvertiser);    
    }

    $scope.$on('reload_influencerGroup', function(event, args) {
        if($rootScope.sideMenuSelections.advertiserId != null || $rootScope.sideMenuSelections.advertiserId !== undefined) {
            $scope.selectedAdvertiser = $rootScope.sideMenuSelections.advertiserId;
        }
        
        $scope.loadInfluencerGroup($scope.selectedAdvertiser);
    });

    $scope.markInfluencer = function (id) {
        $(".kws ul li a").removeClass("active");
        $(".influencers ul li a").removeClass("active");
        $(".preferred ul li").removeClass('activePreferred');

        $('.main-sidebar .projects .nav-sidebar .project .kws li a').removeClass('active');
        $('.main-sidebar .projects .nav-sidebar .project').removeClass('active');
        $('.main-sidebar .projects .nav-sidebar .project').removeClass('not-selected');
        $('.main-sidebar .projects .nav-sidebar .project .kws').hide();

        $('.main-sidebar .campaigns .nav-sidebar .campaign').removeClass('active');

        $('.main-sidebar .influencerGroups .nav-sidebar .influencerGroup.active').addClass('not-selected');
        $('.main-sidebar .influencerGroups .nav-sidebar .influencerGroup .influencers li a').removeClass('active');
        $("#influencerGroup_influencer_" + id).addClass('active');
    }

    $scope.markInfluencerGroup = function(id){
        $(".kws ul li a").removeClass("active");
        $(".influencers ul li a").removeClass("active");
        $(".preferred ul li").removeClass('activePreferred');

        $('.main-sidebar .projects .nav-sidebar .project .kws li a').removeClass('active');
        $('.main-sidebar .projects .nav-sidebar .project').removeClass('active');
        $('.main-sidebar .projects .nav-sidebar .project').removeClass('not-selected');
        $('.main-sidebar .projects .nav-sidebar .project .kws').hide();

        $('.main-sidebar .campaigns .nav-sidebar .campaign').removeClass('active');

        if ($(".influencerGroups .influencerGroup_" + id).hasClass('active')) {
            $('.main-sidebar .influencerGroups .nav-sidebar .influencerGroup').removeClass('not-selected');
        } else {
            $('.main-sidebar .influencerGroups .nav-sidebar .influencerGroup .influencers li a').removeClass('active');
            $('.main-sidebar .influencerGroups .nav-sidebar .influencerGroup').removeClass('active');
            $('.main-sidebar .influencerGroups .nav-sidebar .influencerGroup').removeClass('not-selected');
            $('.main-sidebar .influencerGroups .nav-sidebar .influencerGroup .influencers').hide();
            $(".influencerGroups .influencerGroup_" + id).addClass('active').find("div.influencers").show();
        }
    }

    $scope.selectInfluencerGroup = function(id, name){
        // Mixpanel tracking influencer group item click
        var evtItem = TRACK_EVENTS.PAGE_STATE_MAPPING[$state.current.name];
        if (evtItem) {
            analytics.track(
                TRACK_EVENTS.CLICK_ON_INFLUENCER_GROUP.EVT_NAME,
                {
                    "item": evtItem,
                    "target_type": "influencer Group",
                    "target_name": name,
                    "target_id": id
                }
            );
        }


        $scope.markInfluencerGroup(id);

        $rootScope.sideMenuSelections.keyword = null;
        $rootScope.sideMenuSelections.blog = null;
        $rootScope.sideMenuSelections.channel = null;           
        $rootScope.sideMenuSelections.project = null;
        $rootScope.sideMenuSelections.influencerGroup = id;
        $rootScope.sideMenuSelectedName = {type: "influencer Group", id: id, name: name};
        $rootScope.sideMenuSelectedInfluencerGroup = {id: id, name: name};

        $rootScope.saveParams = {
            mention : 0,
            blog_id : 0,
            project_id : 0,
            channel: 0,
            influencerGroup: id ? id : 0,
            _workaround_group_id: id ? id : 0
        };

        $rootScope.$broadcast('updatePrintHeader', { printHeader : {
            type: "Influencer Group",
            name: $(".influencerGroups .influencerGroup_" + id).text()
        }});

        $rootScope.$broadcast('refreshDashboard', {});
        $rootScope.$broadcast('changeInfluencerGroup', {});

        if($state.current.name == "home.blogPostOverview" || $state.current.name == "home.instagramPostOverview" || $state.current.name == "home.youtubePostOverview") {
            $state.transitionTo("home.dashboard", null, {
                reload: false,
                inherit: false,
                notify: true
            });
        }

        if($state.current.name == "home.influencer" || $state.current.name == "home.detailInfluencerGroup" || $state.current.name == "home.influencerOverview") {
            $state.transitionTo("home.detailInfluencerGroup", {
                influencer_group_id : id ? id : 0
            }, {
                reload: false,
                inherit: false,
                notify: true
            });
        }

    }

    $scope.selectInfluencer = function(id, name, group_id) {
        // Mixpanel tracking influencer group item click
        var evtItem = TRACK_EVENTS.PAGE_STATE_MAPPING[$state.current.name];
        if (evtItem) {
            analytics.track(
                TRACK_EVENTS.CLICK_ON_INFLUENCER.EVT_NAME,
                {
                    "item": evtItem,
                    "target_type": "influencer Group",
                    "target_name": $rootScope.sideMenuSelectedInfluencerGroup.name,
                    "target_id": $rootScope.sideMenuSelectedInfluencerGroup.id,
                    "sub_target_type": "influencer",
                    "sub_target_name": name,
                    "sub_target_id": id
                }
            );
        }

        $scope.markInfluencer(id);

        $rootScope.sideMenuSelections.keyword = null;
        $rootScope.sideMenuSelections.blog = id;
        $rootScope.sideMenuSelections.channel = null;           
        $rootScope.sideMenuSelections.project = null;
        $rootScope.sideMenuSelections.influencerGroup = null;
        $rootScope.sideMenuSelectedName = {
            type: "Influencer Group", 
            id: $rootScope.sideMenuSelectedInfluencerGroup.id, 
            name: $rootScope.sideMenuSelectedInfluencerGroup.name,
            subType: "Influencer",
            subName: name,
            subId: id
        };

        $rootScope.saveParams = {
            mention : 0,
            blog_id : id ? id : 0,
            project_id : 0,
            channel: 0,
            influencerGroup: 0,
            _workaround_group_id: group_id // TODO: Fix hacky solution.. I don't know Angular or how the app works, so this is what I came up with.. Sue me
        };

        $rootScope.$broadcast('updatePrintHeader', { printHeader : {
            type: "Influencer",
            name: $("#influencerGroup_influencer_" + id).text()
        }});

        $rootScope.$broadcast('refreshDashboard', {});

        if($state.current.name == "home.blogPostOverview" || $state.current.name == "home.instagramPostOverview" || $state.current.name == "home.youtubePostOverview") {
            $state.transitionTo("home.dashboard", null, {
                reload: false,
                inherit: false,
                notify: true
            });
        }

        if($state.current.name == "home.influencer" || $state.current.name == "home.detailInfluencerGroup" || $state.current.name == "home.influencerOverview" ) {
            $rootScope.previousPage = $location.absUrl();
            $state.transitionTo('home.influencerOverview', {influencer_id: id}, {
                reload: false,
                inherit: true,
                notify: true
            });
        }
    }

 }])